import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Button, InlineAlert } from '@chillout/ui'
import { QRScanner } from '../shared/QRScanner'

interface PairingScanQRContentProps {
  viewfinderSize: number
  isScanning?: boolean
  error?: string | null
  onScanned: (code: string) => void
  onInvalidScan: () => void
  onSwitchToCode: () => void
}

export function PairingScanQRContent({
  viewfinderSize,
  isScanning = false,
  error,
  onScanned,
  onInvalidScan,
  onSwitchToCode,
}: PairingScanQRContentProps) {
  const { t } = useTranslation()

  const handleScanned = (data: string) => {
    const code = data.trim()
    if (/^\d{6}$/.test(code)) {
      onScanned(code)
    } else {
      onInvalidScan()
    }
  }

  return (
    <View className="flex-1 items-center justify-center">
      <View style={{ width: viewfinderSize, height: viewfinderSize, marginBottom: 24 }}>
        <QRScanner
          active={!isScanning}
          onScanned={handleScanned}
          strings={{
            permissionDescription: t('cashierPairing.cameraPermissionDescription'),
            permissionDeniedDescription: t('cashierPairing.cameraPermissionDeniedDescription'),
            permissionButton: t('cashierPairing.cameraPermissionButton'),
            settingsButton: t('cashierPairing.cameraSettingsButton'),
          }}
        />
      </View>
      <Text className="text-center text-base lg:text-lg text-secondary">
        {t('cashierPairing.scanQRScreenSubtitle')}
      </Text>
      {error ? (
        <View className="mt-4 w-full">
          <InlineAlert message={error} />
        </View>
      ) : null}
      <Button
        label={t('cashierPairing.enterCodeButton')}
        onPress={onSwitchToCode}
        variant="ghost"
        fullWidth={false}
        disabled={isScanning}
        className="mt-4"
      />
    </View>
  )
}
